<template>
  <div
    v-if="themeProfile"
    style="position: absolute; right: 7px; top: 10px;"
  >
    <div
      class="menu"
      :style="{
        background: userSettings.useDarkMode ? '#2b2b2b' : 'white',
        color: userSettings.useDarkMode ? '#FFFFFF' : '#464448'
      }"
      :class="{ open: (showLayerInfoCard || userShow) && !showInfoMenu }"
    >
      <v-tooltip
        v-if="!showLayerInfoCard"
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            id="infoButton"
            label="Se temabeskrivelse"
            aria-label="Se temabeskrivelse"
            class="menu__button"
            v-if="!showLayerInfoCard && !userShow"
            @click="showSmallTile"
            icon
            style="position: absolute;right: 0px; top: 0px; width: 40px; height: 40px;"
            absolute
          >
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </template>
        <span>Se temabeskrivelse</span>
      </v-tooltip>
      <div
        class="menu__content"
        style="border-radius: 5px"
        data-v-step="1"
        v-if="themeProfile"
      >
        <v-layout
          row
          align-center
          justify-start
        >
          <img alt="Bilde som representerer temaet"
            :src="
              themeProfile.hasOwnProperty('mediumImageUrl')
                ? themeProfile.mediumImageUrl
                : getImgUrl(themeProfile.id)
            "
            style="margin: 5px;"
            height="112px"
          />

          <v-layout column>
            <div style="padding-left: 10px; white-space:normal; max-height: 80px;">
              <div
                class="body-2"
                style="text-overflow: ellipsis; white-space: normal; max-height: 80px;"
              >
                {{
                  themeProfile.HovedTemaforklaring
                    ? themeProfile.hovedTemaTitle
                    : themeProfile.appTitle
                }}
              </div>
              <div
                :style="{
                  height: themeProfile.appTitle.length > 40 ? '18px' : '36px'
                }"
                class="caption"
                :class="userSettings.useDarkMode ? 'fade-dark' : 'fade'"
                style="overflow: hidden; height: 34px; width: 290px;"
              >
                {{
                  profileHasHovedDescription
                    ? themeProfile.HovedTemaforklaring
                    : profileHasDescription
                    ? themeProfile.Temaforklaring
                    : "Ingen beskrivelse"
                }}
              </div>
            </div>

            <v-spacer />

            <v-btn
              @click="
                showLayerInfoCard = false;
                userShow = false;
              "
              color="gray"
              absolute
              style="top: 5px; right: 5px"
              icon
              small
              label="Lukk info"
              aria-label="Lukk info"
            >
              <v-icon
                size="15"
                color="gray"
              >mdi-close</v-icon>
            </v-btn>

            <v-layout
              row
              align-center
              justify-start
            >
              <v-btn
                @click="openInfoMenu"
                :disabled="!profileHasDescription"
                block
                class="ml-2 mr-2 mb-0"
                depressed
                color="blue"
                dark
              >Vis temabeskrivelse</v-btn>
            </v-layout>
          </v-layout>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "LayerInfoCard",
  computed: {
    ...mapState([
      "mainThemeID",
      "userSettings",
      "favourites",
      "extentHasBeenChanged",
      "extent",
      "showInfoMenu",
      "guideIsRunning"
    ]),
    showLayerInfoCard: {
      set (showLayerInfoCard) {
        this.setShowLayerInfoCard(showLayerInfoCard);
      },
      get () {
        return this.$store.state.showLayerInfoCard;
      }
    },
    description: function () {
      if (this.showFullDescription) {
        return this.themeProfile.TemaForklaring;
      } else {
        return this.themeProfile.TemaForklaring;
      }
    },
    profileHasDescription () {
      return this.themeProfile.Temaforklaring;
    },
    profileHasHovedDescription () {
      return this.themeProfile.HovedTemaforklaring;
    },
    themeProfile: function () {
      return this.$store.getters["getAddedMapProfile"](this.mainThemeID);
    }
  },
  beforeDestroy () {
    this.showLayerInfoCard = true;
  },
  data: function () {
    return {
      showFullDescription: false,
      extentHasChangedOnce: false,
      userShow: false
    };
  },
  watch: {
    extent: function () {
      if (this.guideIsRunning) {
        return;
      }
      if (this.extentHasChangedOnce) {
        this.showLayerInfoCard = false;
      } else {
        this.extentHasChangedOnce = true;
      }
    },
    guideIsRunning: function (newVal) {
      if (newVal) {
        this.showLayerInfoCard = true;
      }
    }
  },
  methods: {
    ...mapActions([
      "setShowInfoMenu",
      "setShowLayerInfoCard",
      "setSelectedTheme"
    ]),
    showSmallTile: function () {
      this.showLayerInfoCard = true;
      this.userShow = true;
    },
    openInfoMenu: function () {
      this.userShow = false;

      this.setSelectedTheme(this.mainThemeID);
      this.setShowInfoMenu({
        showInfoMenu: true,
        showHovedforklaring: this.themeProfile.hasOwnProperty(
          "HovedTemaforklaring"
        )
      });
    },
    getImgUrl (id) {
      try {
        return require("../../../../assets/medium/" + id + ".jpg");
      } catch (e) {
        require("../../../../assets/medium/" + "placeholder" + ".jpg");
      }
    },
    close () {
      this.setShowInfoMenu(false);
      this.setSelectedTheme(null);
    }
  }
};
</script>

<style lang="scss">
#infoButton > div.v-btn__content {
  writing-mode: vertical-lr;
  text-orientation: upright;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.menu {
  position: absolute;
  top: 0px;
  right: 12px;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0 3px 10px -2px rgba(black, 0.25);
  transition: 0.2s;

  &.open {
    width: 455px;
    height: 123px;
    border-radius: 5px;

    .menu__button {
      color: #999;
      transform: rotate(45deg);
    }

    .menu__content {
      opacity: 1;
      visibility: visible;
    }
  }
}
.menu__button {
  font-weight: 400;
  border: 0;
  color: white;
  position: absolute;
  top: 18px;
  right: 15px;
  font-size: 34px;
  padding: 0;
  width: 20px;
  height: 20px;
  line-height: 12px;
  transition: 0.2s;
  user-select: none;
}
.menu__title {
  font-size: 12px;
  margin: 0 0 13px 0;
}
.menu__content {
  opacity: 0;
  visibility: hidden;
  transition: 0.2s;
}

.fade {
  position: relative;
  height: 3.6em; /* exactly three lines */
}
.fade:after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 1.2em;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1) 50%
  );
}

.fade-dark {
  position: relative;
  height: 3.6em; /* exactly three lines */
}
.fade-dark:after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 1.2em;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(43, 43, 43, 1) 50%
  );
}

.overflow {
  --max-lines: 3;
  position: relative;
  max-height: calc(var(--lh) * var(--max-lines));
  overflow: hidden;
  padding-right: 1rem; /* space for ellipsis */
}
.overflow::before {
  position: absolute;
  content: "...";
  bottom: 0;
  right: 0;
}
.overflow::after {
  content: "";
  position: absolute;
  right: 0;
  width: 1rem;
  height: 1rem;
  background: white;
}
</style>
